/**************************************************
 * Nombre:       Tarjeta_Docente
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import imagen from '../../Recursos/profe_default.png'
import {NEGRITA} from "../../Constantes";

const Tarjeta_Docente = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            ex={{
                border: 1,
                borderColor: '#F7F7F7',
            }}
        >

            <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img ? item.img : imagen} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 8, sm: 8, md: 8}}
                sx={{
                    p: 2
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{
                            fontFamily: NEGRITA,
                            textAlign: 'left',
                            lineHeight: 1.2,
                            fontSize: 14,
                        }}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                    <Typography sx={{
                        fontSize: 12,
                        color: '#6E6E6E',
                        lineHeight: 1.1,
                    }}>{item.titulo}</Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Docente